<template>
    <div class="row" v-if="loading === false">
        <div class="col-12 col-md-6">
            <titan-form ref="formApplication"
                        :schema="application"
                        v-on:saveData="$emit('saveData')"
                        v-on:beforeSave="$emit('validate')"
                        :showMessage="false"
                        :model="formData"
                        :newItem="$route.name === 'createPatient'"
                        :editable="hasPermission('ApplicationsTitan', 'U')"
            >
                <div style="line-height: 18px;" slot="applicationsDrug-item-header" slot-scope="slotData">
                    <strong class="d-block">{{slotData.item.name}}</strong>
                    <div>
                        <span>{{slotData.item.treatmentStart}}</span>
                        <span v-if="slotData.item.treatmentEnd !== null && slotData.item.treatmentEnd.length !== 0">
                            - {{slotData.item.treatmentEnd}}
                        </span>
                    </div>
                    <div v-if="slotData.item.terminationReason !== null && slotData.item.terminationReason.length !== 0">
                        {{slotData.item.terminationReason}}
                    </div>
                </div>
            </titan-form>
        </div>
        <div class="col-12 col-md-6">
            <div class="card" v-if="loadedAttachments">
                <div class="card-header">{{t('Attachments')}}</div>
                <div class="card-body">
<!--                    <file-upload @addedFile="loadAttachmentsData()"-->
<!--                                 :api-url="uploadFileUrl"-->
<!--                                 :class="{'d-none': hasPermission('ApplicationsTitan', 'U') === false}"-->
<!--                    />-->
                    <file-upload-with-encryption
                      @addedFile="loadAttachmentsData()"
                      :multiple="true"
                      :api-url="uploadEncryptedFileUrl"
                      :class="{'d-none': hasPermission('ApplicationsTitan', 'U') === false}"
                    />
                    <div class="mt-2" v-if="formData.applicationsAttachments.length === 0">
                        {{t('Files were not attached to applications')}}
                    </div>
                    <div class="ml-2 mr-2">
                        <a :href="file.link"
                           :key="file.id"
                           :download="file.isClientEncrypted ? file.decryptedFilename : file.file"
                           v-for="file in formData.applicationsAttachments"
                           class="row file-row"
                           target="_blank"
                        >
                            <div class="col col-lg-2 file-col-image">
                                <img :src="file.link" :alt="file.file"
                                     v-if="['jpg', 'png', 'gif'].includes(file.format)">
                                <div class="file-icon" v-if="!(['jpg', 'png', 'gif'].includes(file.format))">
                                    <font-awesome-icon icon="file"/>
                                </div>
                            </div>
                            <div class="col col-lg-10">
                                <div class="h3 mb-0">{{ file.isClientEncrypted ? file.decryptedFilename : file.name  }}</div>
                                <small>{{file.size | prettyBytes}}</small>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <titan-form ref="formApplication2"
                        :schema="application2"
                        v-on:saveData="$emit('saveData')"
                        v-on:beforeSave="$emit('validate')"
                        :showMessage="false"
                        :model="formData"
                        :newItem="$route.name === 'createPatient'"
                        :editable="hasPermission('ApplicationsTitan', 'U')"
            />
            <div class="card" v-if="accepted === true">
                <div class="card-header">
                    <div class="card-header-buttons">
                        <button type="button" class="btn btn-success" @click="$emit('openPrescription')">
                            <font-awesome-icon icon="plus"/>
                            <span>{{t('Add prescription')}}</span>
                        </button>
                    </div>
                    {{t('Prescription')}}
                </div>
                <div class="card-body prescription-history">
                    <time-line name="number"
                               :items="formData.applicationPrescription"
                               v-if="formData.applicationPrescription.length !== 0"
                    >
                        <template slot="item" slot-scope="prescriptionItem">
                            <strong class="d-block">{{t('Packages')}}: {{prescriptionItem.item.number}}</strong>
                            <span class="d-block">{{prescriptionItem.item.createdOn|date}}</span>
                            <accept-action class="delete-prescription"
                                           button-name=""
                                           button-icon="trash-alt"
                                           button-class="btn-danger btn-sm"
                                           :modal-name="t('Delete prescription')"
                                           :modal-text="t('Do you want to delete prescription')"
                                           @accepted="deletePrescription(prescriptionItem.item.id)"
                            />
                        </template>
                    </time-line>
                </div>
            </div>
        </div>

      <div class="col-12">
            <titan-form ref="formApplication3"
                        :schema="application3"
                        v-on:saveData="$emit('saveData')"
                        v-on:beforeSave="$emit('validate')"
                        :showMessage="false"
                        :model="formData"
                        :newItem="$route.name === 'createPatient'"
                        :editable="hasPermission('ApplicationsTitan', 'U')"
            >
                <template slot="epicrisis-header-buttons" slot-scope="data">
                    <epicrisis-pattern :applicationId="$route.params.id" @select="selectEpicrisis($event)" class="d-inline-block"/>
                </template>
            </titan-form>
        </div>
    </div>
</template>
<script>
    import TitanForm from '../../../core/Form/Form'
    import FileUpload from './file-upload'
    import FileUploadWithEncryption from './file-upload-with-encryption'
    import VueFormGenerator from 'vue-form-generator';
    import {validateMultipleForms} from '../../../core/Libs/utils';
    import EpicrisisPattern from './epicrisis-pattern';
    import {apiLink} from '../../../store/api'
    import TimeLine from '../../../core/TimeLine';
    import AcceptAction from '../../../core/AcceptAction';

    export default {
        components: {
            AcceptAction,
            TimeLine,
            EpicrisisPattern,
            TitanForm,
            FileUpload,
            FileUploadWithEncryption,
        },
        props: {
            formData: {
                type: Object,
                required: true,
            },
            accepted: {
                type: Boolean,
                default: true,
            },
        },
        mounted() {
            this.setApplicationTypeValues();
            setTimeout(() => {
                this.loadedAttachments = true;
            }, 50)
        },
        watch: {
            insuranceCode(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.setApplicationTypeValues();
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                    }, 50);
                }
            },
        },
        computed: {
            uploadFileUrl() {
                return apiLink() + 'applications/upload-file/' + this.$route.params.id + '?XDEBUG_SESSION_START=titan';
            },
            uploadEncryptedFileUrl() {
                return apiLink() + 'applications/upload-file-encrypted/' + this.$route.params.id + '?XDEBUG_SESSION_START=titan';
            },
            insuranceCode() {
                return !this.formData.patient.insurance ? null : this.formData.patient.insurance.code;
            },
        },
        methods: {
            deletePrescription(id) {
                this.$store.dispatch('applicationPrescriptions/delete', id).then(() => {
                    this.$store.dispatch('alert/success', 'Prescription was successfully deleted');
                    this.$emit('reload');
                });
            },
            selectEpicrisis(data) {
                this.formData.epicrisis = data.text;
            },
            loadAttachmentsData() {
                this.$store.dispatch('applications/attachments', this.$route.params.id);
            },
            isValid() {
                return validateMultipleForms([
                    this.$refs.formApplication,
                    this.$refs.formApplication2,
                    this.$refs.formApplication3,
                ]);
            },
            setApplicationTypeValues() {
                const fieldIndex = this.application[0].fields.findIndex(res => {
                    return res.model === 'applicationType';
                });
                this.application[0].fields[fieldIndex].values = [
                    {
                        id: 'first',
                        name: this.insuranceCode === 25 ? this.t('The beginning') : this.t('First'),
                    }, {
                        id: 'other',
                        name: this.insuranceCode === 25 ? this.t('Continuing') : this.t('Other'),
                    }
                ];
            }
        },
        data() {
            return {
                loading: false,
                loadedAttachments: false,
                application: [
                    {
                        name: this.t('Additional patient details for request'),
                        type: 'main',
                        fields: [
                            {
                                type: 'titanSelect',
                                constant: true,
                                label: this.t('Application type'),
                                model: 'applicationType',
                                values: [], // Values are changed dynamically via method setApplicationTypeValues
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Beginning / Continuing'),
                                model: 'typeText',
                                textAppend: this.t('month / year'),
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                visible: () => {
                                    return this.insuranceCode === 25;
                                }
                            }, {
                                type: 'titanAutocomplete',
                                label: this.t('Diagnosis name'),
                                model: 'diagnosis',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                minStringLength: -1,
                                values: (string) => {
                                    return this.$store.dispatch('indications/codeBook', {page: 1, conditions: []});
                                },
                            }, {
                                type: 'titanAutocomplete',
                                label: this.t('MKCH10'),
                                model: 'diagnosisCode',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                minStringLength: -1,
                                selected: (item) => {
                                    this.formData.diagnosisCode = item.code;
                                },
                                valueLabel: (item) => {
                                    return item.code + ' - ' + item.name;
                                },
                                values: (string) => {
                                    return this.$store.dispatch('diseaseClassification/codeBook', {
                                        page: 1,
                                        conditions: []
                                    });
                                },
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Daily dosage'),
                                model: 'dailyDosage',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                            }, {
                                type: 'titanSelect',
                                label: this.t('Drug'),
                                model: 'drug',
                                codeBook: 'drugs',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                singleLabel: (item) => {
                                    return item.name + '<br><small>' + item.package + '</small>';
                                },
                                option: (item) => {
                                    return item.name + '<br><small>' + item.package + '</small>';
                                }
                            }, {
                                type: 'input',
                                inputType: 'number',
                                label: () => {
                                    return this.insuranceCode === 25 || this.insuranceCode === 24
                                        ? this.t('Number of pieces / packages')
                                        : this.t('Suggested packages per month');
                                },
                                model: 'suggestedPackagesPerMonth',
                                max: 999,
                                required: true,
                                validator: VueFormGenerator.validators.number,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                            }, {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('Period'),
                                model: 'period',
                                max: 999,
                                required: true,
                                validator: VueFormGenerator.validators.number,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                visible: () => {
                                    return this.insuranceCode === 24;
                                }
                            }, {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('Suggested original packages'),
                                model: 'suggestedOriginalPackages',
                                max: 999,
                                required: true,
                                validator: VueFormGenerator.validators.number,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                visible: () => {
                                    return this.insuranceCode === 27;
                                }
                            }, {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('Suggested original packages for period'),
                                model: 'suggestedOriginalPackagesPeriod',
                                max: 999,
                                required: true,
                                validator: VueFormGenerator.validators.number,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                textAppend: this.t('months'),
                                visible: () => {
                                    return this.insuranceCode === 27;
                                }
                            }, {
                                type: 'textArea',
                                label: () => {
                                    if (this.insuranceCode === 25) {
                                        return this.t('Time period');
                                    } else if (this.insuranceCode === 24) {
                                        return this.t('Estimated total duration of treatment');
                                    }
                                    return this.t('Expected treatment duration')
                                },
                                model: 'expectedTreatmentDuration',
                                max: 255,
                                required: true,
                                validator: VueFormGenerator.validators.string,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                            }, {
                                type: 'textArea',
                                label: this.t('Current therapy'),
                                model: 'currentTherapy',
                                visible: () => {
                                    return this.insuranceCode === 25;
                                },
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                            }
                        ]
                    }, {
                        name: this.t('Drugs'),
                        type: 'oneToMany',
                        model: 'applicationsDrug',
                        listModel: 'street',
                        acceptAction: true,
                        disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                        visible: () => {
                            return this.insuranceCode === 24;
                        },
                        fields: [
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Drug name'),
                                model: 'name',
                                maxLength: 255,
                                required: true,
                                validator: VueFormGenerator.validators.string,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Treatment start'),
                                model: 'treatmentStart',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Treatment end'),
                                model: 'treatmentEnd',
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                            }, {
                                type: 'textArea',
                                label: this.t('Termination reason'),
                                model: 'terminationReason',
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false
                            }
                        ]
                    }, {
                        name: this.t('Fill in after application approval'),
                        type: 'main',
                        visible: () => {
                            return this.formData.status !== undefined
                                && this.formData.status !== null
                                && this.formData.status.slug === 'accepted';
                        },
                        fields: [
                            {
                                type: 'input',
                                inputType: 'number',
                                label: this.t('Approved packages'),
                                model: 'approvedPackages',
                                max: 999,
                                disabled: this.hasPermission('ApplicationsTitan', 'U') === false
                            }, {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Approval evidence'),
                                model: 'approvalEvidenceNo',
                                disabled: this.hasPermission('ApplicationsTitan', 'U') === false
                            }, {
                                type: 'textArea',
                                inputType: 'text',
                                label: this.t('Approval comments'),
                                model: 'approvalComments',
                                disabled: this.hasPermission('ApplicationsTitan', 'U') === false
                            }
                        ]
                    }
                ],
                application2: [
                    {
                        name: this.t('Additional patient details for request'),
                        type: 'main',
                        fields: [
                            {
                                type: 'textArea',
                                inputType: 'text',
                                label: this.t('Lab results'),
                                model: 'labResults',
                                rows: 4,
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                visible: () => {
                                    return this.insuranceCode !== 27
                                        && this.insuranceCode !== null
                                        && this.insuranceCode !== 25;
                                }
                            }, {
                                type: 'textArea',
                                inputType: 'text',
                                label: this.t('Radiodiagnostic results'),
                                model: 'radiodiagnosticResults',
                                rows: 4,
                                required: false,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                visible: () => {
                                    return this.insuranceCode !== 27 && this.insuranceCode !== null;
                                }
                            }, {
                                type: 'textArea',
                                inputType: 'text',
                                label: this.t('Other therapies results'),
                                model: 'otherTherapies',
                                rows: 4,
                                required: false,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                                visible: () => {
                                    return this.insuranceCode !== 27 && this.insuranceCode !== null;
                                }
                            }, {
                                type: 'textArea',
                                inputType: 'text',
                                label: this.t('Other information'),
                                model: 'otherInformation',
                                rows: 4,
                                required: () => {
                                    return this.insuranceCode === 27;
                                },
                                validator: () => {
                                    if (this.insuranceCode === 27) {
                                        return VueFormGenerator.validators.required;
                                    }
                                    return [];
                                },
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                            },
                        ]
                    },
                ],
                application3: [
                    {
                        name: this.t('Justification for the indication of the drug (Epicrisis)'),
                        type: 'main',
                        key: 'epicrisis',
                        fields: [
                            {
                                type: 'titanRedactor',
                                label: this.t('Write a epicrisis'),
                                model: 'epicrisis',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                            }
                        ]
                    }, {
                        name: this.t('Personal patient notes (for doctor only)'),
                        type: 'main',
                        fields: [
                            {
                                type: 'titanRedactor',
                                label: this.t('Results of laboratory examinations and conclusions'),
                                model: 'personalNotes',
                                required: false,
                                disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                            }
                        ]
                    }
                ]
            }
        }
    }
</script>
<style lang="scss">
    .file-icon {
        text-align: center;
        display: block;
        width: 50px;
        height: 45px;
        line-height: 45px;
        background: #eff1f4;
        color: #8e8e8e;
        border-radius: 4px;
    }

    .prescription-history {
        .time-line {
            padding-bottom: 0;

            .time-line-item {
                position: relative;
                padding-right: 40px;
                margin-bottom: 5px;

                &:hover .delete-prescription {
                    display: block ! important;
                }

                .delete-prescription {
                    position: absolute;
                    top: 10px;
                    right: 0;
                    display: none ! important;
                }
            }
        }
    }

    .v-transmit__upload-area {
      border-width: 0 ! important;
      min-height: 0 ! important;
    }

    .file-row {
      min-height: 50px;
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px solid rgba(0, 0, 0, 0.125);
      color: #000;

      &:hover {
        color: #000;
      }

      .file-col-image {
        img {
          object-fit: cover;
          height: 100%;
          width: 100%;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/private/applications/cardio-form.vue